export const API_FEEDBACK = "https://uat-fb-api.pizza4ps.io/feedback/api";

export const API_URL_RECEIPT = "https://uat-receipt.pizza4ps.io/eri/api";

export const API_DELI = "https://uat-deli-v2.pizza4ps.io/v2";

export const URL_DELI = "https://uat-deli-v2-consumer.pizza4ps.io";

export const API_BYOD = "https://vn-byod-api-uat.pizza4ps.io/byod-api";

export const URL_BYOD = "https://vn-byod-uat.pizza4ps.io/";

export const URL_BYOD_IN = "https://in-byod.uat.pizza4ps.io";

export const URL_TALENT_LMS = "https://talent-lms-uat.pizza4ps.io";

export const URL_FB_BACKOFFICE = "https://uat-deli-v2-bo.pizza4ps.io/feedback/";
export const URL_TTO = "https://vn-tto.uat.pizza4ps.io";

export const API_TRAPI = "https://cms.pizza4ps.com";

export const TIME_RESET_FEEDBACK = "30";

export const TIME_RESET_FEEDBACK_THANKYOU = "10";

export const firebaseConfig = {
   apiKey: "AIzaSyDbFXVnMR3zoq3UT2U8D5lU8yEJiLcVpSA",
   authDomain: "map-4ps-prod.firebaseapp.com",
   databaseURL: "map-4ps-prod.firebaseapp.com",
   projectId: "map-4ps-prod",
};

export const KEY_COMMUNICATE_FEEDBACK = {
   CHANGE_LANG_EN: "CHANGE_LANG_EN",
   CHANGE_LANG_VI: "CHANGE_LANG_VI",
};

export const KEY_STORAGE = {
   CURRENTURL: "currentUrl",
   LANG: "lang",
};

export const DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm";

export const DATE_FORMAT = "DD/MM/YYYY";

export const PLATFORM = "Web";

export const CHANNEL = {
   BYOD: "BYOD",
   DINE_IN: "DINE_IN",
};

export const SALES_CHANNEL = {
   BYOD: "DINE-IN-BYOD",
   BO: "DINE-IN-BO",
   TTO: "DINE-IN-TTO",
};

export const KEY_COMMUNICATE_BYOD = {
   ACTIVE_FULL_SCREEN: "ACTIVE_FULL_SCREEN",
   CLEAN_ORDER_INFO: "CLEAN_ORDER_INFO",
   HIDE: "HIDE",
   FINISHED: "FINISHED"
};

export const TIME_CLEAN_ORDER_BYOD = 5;

export const MAX_FILES_SIZE = 1024 * 1024 * 9; // 9M

export const STORAGE_KEY = {
   VERSION: "vs",
};

export const LANG = {
   EN: "en",
   VI: "vi",
   JA: "ja",
   AS: "as",
   KOR: "ko",
   ZH: "zh"
};

export const COUNTRY = {
   EN: "EN",
   VN: "VN",
   JP: "JP",
   IN: "IN",
   ID: "ID",
};

export const QUESTION_TYPE = {
   SINGLE: 1,
   MULTIPLE: 2,
   INTRUCTION: 3,
};

export const ANSWER_TYPE = {
   RATING: 5,
   CHOICE: 1,
   TEXT_INPUT: 2,
   CHOICE_INPUT: 3,
   CLOSE: 6
};

export const SOURCE_NAME_LOGGING = "feedback-consumer-uat";

export const BRAND_NAME = {
   IPPUDO: "Ippudo",
   Pizza4PS: "4Ps",
};

export const PARAMS = {
   LANG: 'lang',
   HIDE_LANG: "hide_lang"
}

export const CLARITY_ID = "taydflaq3k";

export const FMCG_TIME_EXPIRATION_MINUTES = "";